<script>
	import {onMount} from 'svelte';
	import BasketList from "../../lib/components/BasketList.svelte";
	import ModalRenderer from "../../lib/components/ModalRenderer.svelte";
	import Footer from "../../lib/components/Footer.svelte";
	import { Basket } from "../../lib/stores/basket";
	let scrollPosition = 0;
	import Sidebar from '../../lib/components/SideBar.svelte';
	import FilterBar from '../../lib/components/FiltersBar.svelte';
	import { navigate } from "svelte-navigator";
	let sidebar_show = false;
	let FilterBar_show = false;
	import GTM from '../../utils/gtm';
	export let searchQuery = '';
	export let darkheader = false;
	GTM.page();

	onMount(() => {
		// Basket.subscribe(value => {
		//     window.localStorage.setItem('basket', JSON.stringify(value));
		// 	console.log('updated');
		// })
	})

	let isSearchOpen = false;

	function toggleSearch() {
		isSearchOpen = !isSearchOpen;
	}
</script>
<svelte:window bind:scrollY={scrollPosition} />
<header id="header" class="fixed-top {darkheader === true ? 'dark-header' : 'normal-header'}" class:header-alt={scrollPosition>0}>
	<div class="container-fluid">
		<div class="row">
			<button class="menu-btn" on:click={() => sidebar_show = !sidebar_show}>
				<img src="/images/menu.png" class="img-fluid" alt="Menu">
			</button>
			<div class="col-xl-12 d-flex align-items-center justify-content-center position-relative">
				<a href="/" class="logo"><img src="/images/logo.png" alt="" class="img-fluid"></a>
				<button class="btn search-btn-mobile {` ${isSearchOpen ? 'hide' : ''}`}" on:click={toggleSearch}>	
					<img src="/images/search.png" alt="search">
				</button>
				<div class="search {`search-box ${isSearchOpen ? 'open' : ''}`}">
					<div class="input-group">
						<button class="btn search-close" on:click={toggleSearch}>	
							<i class="fa fa-close" />
						</button>
						<form class="search-form" action="/search" method="get" on:submit|preventDefault={() =>  navigate(`/search/${searchQuery}`)}>
							<div class="position-relative sbox">
								<input type="text" class="form-control sbox-input" placeholder="Search" bind:value={searchQuery}>
								<button class="input-group-append btn {searchQuery == ''? 'disabled' : ''}">
									<span class="input-group-text">
										<img src="/images/search.png" alt="search">
									</span>
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="text-right cart animate__animated animate__slideInDown animate__faster">
				<a href="#" on:click|preventDefault={e => Basket.open() }>
					{#if $Basket.items.length > 0}
						<sup class="cart-count">
							{$Basket.items.reduce((t,c) => t+c.pricelist_by_avl_sizes.reduce((to,cr) => to+(cr.quantity ? parseInt(cr.quantity) : 0),0),0)}
						</sup>
					{/if}
					<img class="cart-icon" src="/images/cart.png" alt="cart">
				</a>
			</div>
		</div>
		<Sidebar bind:show={sidebar_show}/>
	</div>
</header>
<slot></slot>
<ModalRenderer/>
<BasketList/>
<Footer />
<a href="https://wa.me/919606020090" class="whatsapp-btn" target="_blank">
	<img src="/images/whatsapp-01.png" class="img-fluid" alt="whatsapp">
</a>
<button class="filters-btn" on:click={() => FilterBar_show = !FilterBar_show}>
	<img src="/images/filter.png" class="img-fluid" alt="Filter">
</button>
<FilterBar bind:show={FilterBar_show} />
<style lang="scss">
	@import "../../scss/styles.scss";

	.search-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.search-box.open {
		display: block;
	}

	.cart {
		font-size: 2em;
		position: absolute;
		right: 20px;
		top: 15px;
	}

	.menu-btn {
		position: absolute;
		z-index: 99;
		background: none;
		border: none;
		top: 20px;
		left: 20px;
	}

	.menu-btn img {
		width: 32px;
		height: 32px;
	}

	.filters-btn {
		position: fixed;
		background: none;
		border: none;
		bottom: 40px;
		right: 10px;
		z-index: 99;
	}

	.filters-btn img {
		width: 32px;
		height: 32px;
		z-index: 99;
	}

	.search {
		position: absolute;
		right: 70px;
		top: 50%;
		transform: translateY(-50%);
	}

	.input-group-text {
		padding: 2px 10px;
	}

	.search img {
		max-width: 24px;
		height: 24px;
	}

	.cart a {
		position: relative;
	}

	.cart a sup {
		color: #000;
	}

	.cart-count {
		background: #fff;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		position: absolute;
		right: -10px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
	}

	.whatsapp-btn {	
		position: fixed;
		background: none;
		border: none;
		bottom: 35px;
		left: 10px;
		z-index: 99;
	}
	
	.whatsapp-btn img {
		width: 32px;
		height: 32px;
		z-index: 99;
	}

	.cart-icon {
		max-width: 30px;
		height: 30px
	}

	.dark-header {
		background: rgba(0, 0, 0, 0.9);
	}

	.sbox {
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fff;
		border-radius: 8px;
		overflow: hidden;
	}

	.sbox .input-group-append {
		padding: 0;
	}

	.sbox .form-control {
		border-radius: 0;
	}

	.sbox .input-group-text {
		margin-left: -10px;
		background: #fff;
		border-left: none;
		padding: 0.375rem 0.75rem;
		margin-top: 0px;
	}

	.search-btn-mobile {
		display: none;
	}

	.search-btn-mobile img {
		width: 30px;
		max-width: 100%;
		margin: -2px 6px 0 6px;
	}

	.search-close {
		display: none;
	}

	.search-close i {
		font-size: 20px;
		padding: 2px 2px 0 2px;
		color: rgba(8, 6, 2,1);
	}

	.btn.disabled, .btn:disabled {
		pointer-events: none;
	}

	@media only screen and (min-width: 300px) and (max-width: 656px) {
		.search-box {
			display: none;
			/* Add your styling for the search box here */
		}

		.search-btn-mobile {
			display: block;
			color: #fff;
			padding: 0;
			position: absolute;
			right: 48px;
		}

		.search-btn-mobile.hide {
			display: none;
		}

		.search-close {
			position: absolute;
			display: block;
			left: 0;
			z-index: 99;
		}

		.search-form .form-control {
			padding-left: 36px;
		}

		:global(.top-border) {
			margin-top: 30px;
			border-top: 1px solid #cccccc;
		}
	}
</style>